import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { ClaimNumberSchema, InspectionDetailsSchema } from '../model/index.js';
export const ConfirmScheduledInspectionSchemas = {
    params: z.object({
        claimNumber: ClaimNumberSchema,
        inspectionId: InspectionDetailsSchema.shape.inspectionId,
    }),
    headers: ApiLambdalerAuthHeaderSchema.pick({ requestActor: true }).required({
        requestActor: true,
    }),
};
export const ConfirmScheduledInspectionRequestSchema = ConfirmScheduledInspectionSchemas.params.merge(ConfirmScheduledInspectionSchemas.headers);
export const ConfirmScheduledInspectionApiSchema = ConfirmScheduledInspectionSchemas;
